import React from 'react';

import { BrowserRouter, Switch, Route } from 'react-router-dom';
import { ThemeProvider } from '@material-ui/core/styles';
// import swal from 'sweetalert';

import theme from './assets/style/themeConfig';
import Layout from './components/layout/Layout';
import { home, privacyPolicy, termsOfService, chatbot, map, recallId } from './routes/routes.json';
import { AppConfigProvider } from "./context/AppConfigContext";
import Main from './views/Main';
import RouterScrollToTop from './utils/RouterScrollToTop';
import NotFound from './views/NotFound';

import 'react-image-lightbox/style.css';


const App = () => {
  // window.addEventListener('offline', () => {
  //   swal(
  //     'Offline Mode!',
  //     'We detected that your device is offline, probably React Cookbook is not working properly, please check your connection.',
  //     'warning'
  //   );
  // });

  //console.log(process.env);

  return (
      <BrowserRouter>
        <ThemeProvider theme={theme}>
          <RouterScrollToTop />
              <Switch>
                <Route exact path={privacyPolicy} render={() => {window.location.href="/privacy-policy.html"}} />
                <Route exact path={termsOfService} render={() => {window.location.href="/terms-and-conditions.html"}} />
                <Route exact path={chatbot} render={() => {window.location.href="/chatbot.html"}} />
                <Route exact path={map} render={() => {window.location.href="/map.html"}} />
                <Route component={DefaultContainer}/>
              </Switch>
        </ThemeProvider>
      </BrowserRouter>
  );
};

const DefaultContainer = () => {
  return (
    <AppConfigProvider>
      <Layout>
        <Switch>
          <Route exact path={home} component={Main} />
          <Route path={recallId} component={Main} /> {/* Dynamic Recall Route */}
          <Route component={NotFound} />
        </Switch>
      </Layout>
    </AppConfigProvider>
  );
};

// const DetailContainer = (props) => (
//   <Route exact path={props.path} component={Main} />
// )

export default App;
